<template>
  <div />
</template>

<script>

/**
 * Vue: Product comparison (product-comparison)
 * -----------------------------------------------------------------------------
 * Carousel of products comparing parameters.
 * - Limited interactivity section.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
// eslint-disable import/no-named-as-default
import { mapState } from 'vuex'
import Splide from '@splidejs/splide'
import { debounce } from '~/helpers/general'
import { values as breakpoints } from '~/config/breakpoints'

export default {
  name: 'ProductComparison',

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        slideCount: 0,
      }),
    },
  },

  data() {
    return {
      splide: null,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  mounted() {
    this.container = document.querySelector(`#vue-element .section-${this.liquid.sectionId}`)
    this.carousel = this.container.querySelector('.splide')
    this.slideCountContainer = this.carousel.querySelector('.js-splide-counter')
    this.createCarousel()
    this.bindEventListeners()

    let breadIntervall = setInterval(function() {
     if (window.BreadPayments) {
       this.loadBreadALA();
       clearInterval(breadIntervall);
     }
   }, 100);
  },

  methods: {

    loadBreadALA() {
   
    let breadAsLowAsContainers = document.getElementsByClassName("bread-as-low-as-container");
    let breadPlacements = []
    let setup = {integrationKey: '4ad64e7a-d472-4404-bf33-e7ff260ec543'};
    for (const container of breadAsLowAsContainers) {
        let placement = {};
        let currency = "USD";
        placement.allowCheckout = false;
        placement.domID = container.id;
        placement.order = {};
        placement.order.items = [];
  
        let price = Number(container.dataset.price);
  
        placement.order.subTotal = {value: price, currency: currency};
        placement.order.totalPrice = {value: price, currency: currency};
        placement.order.currency = currency;
        placement.order.totalShipping = {value: 0, currency: currency};
        placement.order.totalTax = {value: 0, currency: currency};
        placement.order.totalDiscounts = {value: 0, currency: currency};
        breadPlacements.push(placement);
      }
      window.BreadPayments.setup(setup);
      window.BreadPayments.on('INSTALLMENT:APPLICATION_DECISIONED', () => {});
      window.BreadPayments.on('INSTALLMENT:APPLICATION_CHECKOUT', () => {});
      window.BreadPayments.registerPlacements(breadPlacements);
      window.BreadPayments.__internal__.init();
    },

    /**
     * Bind event listeners.
     */
    bindEventListeners() {
      window.visualViewport.addEventListener('resize', debounce(() => {
        this.handleResize()
      }, 300), { passive: true })
    },

    /**
     * Create carousel.
     */
    createCarousel() {
      this.splide = new Splide(this.carousel, {
        gap: 24,
        perPage: 2,
        perMove: 1,
        focus: 0,
        omitEnd: true,
        pagination: false,
        keyboard: true,
        breakpoints: {
          [breakpoints.l - 1]: {
            perPage: 1,
            perMove: 1,
            gap: 8,
            focus: 0,
            omitEnd: true,
          },
        },
      })

      if (this.slideCountContainer) {
        this.splide.on('moved', (index) => {
          const slideIndex = this.isMobile ? index + 1 : index + 2
          this.slideCountContainer.innerHTML = `${slideIndex}/${this.liquid.slideCount}`
        })
      }

      this.splide.mount()
      this.setInitialSlideCount()
    },

    /**
     * Handle resize.
     */
    handleResize() {
      this.setInitialSlideCount()
    },

    /**
     * Set initial slide count.
     */
    setInitialSlideCount() {
      if (this.slideCountContainer) {
        const initialIndex = this.isMobile ? 1 : 2
        this.slideCountContainer.innerHTML = `${initialIndex}/${this.liquid.slideCount}`
      }
    },
  },
}
</script>

<style lang="scss">
@import './product-comparison';
@import '@/components/splide';
</style>
